import React, { useState, useEffect } from 'react';
import { Plus, Edit2, Trash2, Calendar, FileText } from 'lucide-react';
import transazioniService from '../services/api-transazioni';
import TransazioneModal from './TransazioneModal';

// MODIFICA/imposta DA COSÌ:
// const API_BASE_URL = 'http://localhost:3006/api';

// A COSÌ (Valido sia in locale con il proxy di Vite, sia online su gledger.net):
const API_BASE_URL = '/api';


const Giornale = ({ userId }) => {
  const [transazioni, setTransazioni] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState('create');
  const [selectedTransazione, setSelectedTransazione] = useState(null);
  const [conti, setConti] = useState([]);

  useEffect(() => {
    loadTransazioni();
    loadConti();
  }, [userId]);

  const loadTransazioni = async () => {
    try {
      setLoading(true);
      const data = await transazioniService.getTransazioni('user001'); // ID corretto
      setTransazioni(data);
      setError('');
    } catch (err) {
      setError('Errore caricamento transazioni');
      console.error('Load transazioni error:', err);
    } finally {
      setLoading(false);
    }
  };

  const loadConti = async () => {
    try {

      debugger;

      // Carica i conti transazionali per il select nel modale

      //\\bef const response = await fetch(`http://localhost:3006/api/conti?user_id=user001`); // ID corretto
      const response = await fetch(`${API_BASE_URL}/conti?user_id=user001`); // ID corretto da impostare tenant?

      const data = await response.json();
      setConti(data.filter(c => c.hasTransactions)); // Solo conti transazionali
    } catch (err) {
      console.error('Load conti error:', err);
    }
  };

  const handleNewTransazione = () => {
    setSelectedTransazione(null);
    setModalMode('create');
    setIsModalOpen(true);
  };

  const handleEditTransazione = (transazione) => {
    setSelectedTransazione(transazione);
    setModalMode('edit');
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedTransazione(null);
  };

  const handleModalSave = () => {
    loadTransazioni(); // Ricarica le transazioni dopo il salvataggio
  };

  const handleDeleteTransazione = async (transazioneId) => {
    if (!window.confirm('Sei sicuro di voler eliminare questa transazione?')) {
      return;
    }

    try {
      await transazioniService.deleteTransazione(transazioneId);
      loadTransazioni(); // Ricarica le transazioni dopo l'eliminazione
    } catch (err) {
      console.error('Delete transazione error:', err);
      alert('Errore durante l\'eliminazione della transazione');
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('it-IT', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric' 
    });
  };

  const formatCurrency = (amount) => {
    if (!amount) return '€0,00';
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-gray-500">Caricamento giornale...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-red-500">{error}</div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center space-x-2">
          <FileText className="w-6 h-6 text-blue-600" />
          <h1 className="text-2xl font-bold text-gray-900">Giornale</h1>
        </div>
        <button 
          onClick={handleNewTransazione}
          className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          <Plus className="w-4 h-4" />
          <span>Nuova Transazione</span>
        </button>
      </div>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Data
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Descrizione Transazione
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Descrizione Dettaglio
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Conto
                </th>
                <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                  D/A
                </th>
                <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Importo
                </th>
                <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Azioni
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {transazioni.map((transazione) => (
                <React.Fragment key={transazione.id}>
                  {transazione.dettagli.map((dettaglio, dettaglioIndex) => (
                    <tr key={dettaglio.id} className="hover:bg-gray-50">
                      {/* Data - solo sulla prima riga */}
                      {dettaglioIndex === 0 && (
                        <td 
                          rowSpan={transazione.dettagli.length}
                          className="px-4 py-3 text-sm text-gray-900 border-r border-gray-200 align-top"
                        >
                          <div className="flex items-center space-x-1">
                            <Calendar className="w-4 h-4 text-gray-400" />
                            <span>{formatDate(transazione.data_transazione)}</span>
                          </div>
                        </td>
                      )}
                      
                      {/* Descrizione Transazione - solo sulla prima riga */}
                      {dettaglioIndex === 0 && (
                        <td 
                          rowSpan={transazione.dettagli.length}
                          className="px-4 py-3 text-sm font-medium text-gray-900 border-r border-gray-200 align-top"
                        >
                          {transazione.descrizione}
                        </td>
                      )}
                      
                      {/* Descrizione Dettaglio */}
                      <td className="px-4 py-3 text-sm text-gray-900">
                        {dettaglio.descrizione_dettaglio}
                      </td>
                      
                      {/* Conto */}
                      <td className="px-4 py-3 text-sm text-gray-900">
                        {dettaglio.nome_conto}
                      </td>
                      
                      {/* DARE/AVERE */}
                      <td className="px-4 py-3 text-sm text-center">
                        <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                          dettaglio.importo >= 0 
                            ? 'bg-red-100 text-red-800'  // DARE = rosso
                            : 'bg-green-100 text-green-800' // AVERE = verde
                        }`}>
                          {dettaglio.importo >= 0 ? 'D' : 'A'}
                        </span>
                      </td>
                      
                      {/* Importo */}
                      <td className="px-4 py-3 text-sm font-mono text-right">
                        {formatCurrency(Math.abs(dettaglio.importo))}
                      </td>
                      
                      {/* Azioni - solo sulla prima riga */}
                      {dettaglioIndex === 0 && (
                        <td
                          rowSpan={transazione.dettagli.length}
                          className="px-4 py-3 text-sm text-center border-l border-gray-200 align-top"
                        >
                          <div className="flex items-center justify-center space-x-2">
                            <button
                              onClick={() => handleEditTransazione(transazione)}
                              className="p-1 text-blue-600 hover:bg-blue-50 rounded transition-colors"
                            >
                              <Edit2 className="w-4 h-4" />
                            </button>
                            <button
                              onClick={() => handleDeleteTransazione(transazione.id)}
                              className="p-1 text-red-600 hover:bg-red-50 rounded transition-colors"
                            >
                              <Trash2 className="w-4 h-4" />
                            </button>
                          </div>
                        </td>
                      )}
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
        
        {transazioni.length === 0 && (
          <div className="text-center py-12">
            <FileText className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">Nessuna transazione</h3>
            <p className="text-gray-500">Inizia aggiungendo la tua prima transazione</p>
          </div>
        )}
      </div>

      {/* Modale Transazione */}
      <TransazioneModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        transazione={selectedTransazione}
        onSave={handleModalSave}
        mode={modalMode}
        contiList={conti}
      />
    </div>
  );
};

export default Giornale;
